<template>
  <div class="job-details">
    <div class="modal">
      <div class="modal-header">
        <h4 class="modal-title">{{data.title}}</h4>
        <div>{{data.location}}</div>
      </div>
      <div class="modal-body">
        <div class="job-description" v-html="data.body"></div>
      </div>
      <div class="modal-footer">
        <div class="left">
        <a
          title="Email"
          class="email"
          :href="'mailto:?subject=' + getEncodedText(data.title) + '&body=Hi!%0A%0AId%20like%20to%20recommend%20you%20this%20job%3A%0A' + getEncodedText(replaceSpaces(data.itemUrl)) + '%0A%0ARegards'"
          target="_blank"
        >
        </a>
        <a
          title="LinkedIn"
          class="linkedin"
          :href="'https://www.linkedin.com/cws/share?url='+data.itemUrl"
          target="_blank"
          onclick="window.open(this.href,'li_share','width=600,height=294,scrollbars=yes,resizable=yes,menubar=no,status=no,location=no,toolbar=no');return false;"
        >
        </a>
        </div>
        <div class="right">
        <a class="button white inline-right" @click="closeModal">{{labels("cancel")}}</a>
        <a class="button blue inline-right" v-if="data.applicationURL" :href="data.applicationURL" target="_blank">{{labels("apply")}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLabel } from "../services/labels.js";

export default {
  name: "JobDetails",
  props: ["data"],
  components: {},
  mounted () {
    document.body.classList.add("noscroll");
  },
  destroyed () {
    document.body.classList.remove("noscroll");
  },
  methods: {
    labels(name) {
      return getLabel(name);
    },
    getEncodedText(text) {
      return encodeURIComponent(text);
    },
    replaceSpaces(text) {
      if (!text) return "";
      return text.replace(new RegExp(' ', 'g'), '-');
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style>
.job-details {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  width: 800px;
  max-width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.modal-header {
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 10px;
  
}

.modal-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px 0;
  max-height: 70vh;
  display:flex;
  flex-direction: column;
}

.modal-body ul {
  list-style: disc !important;
  margin-left: 20px !important;
}

.modal-body img {
  max-width: 100%;
}

.modal-footer {
  border-top: 1px solid #d4d4d4;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
}

.left {
  display: flex;
}

.left > a {
  width: 32px;
  height: 32px;
  background-size: 32px 32px;
  margin-right: 10px;
}

.email {
  background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='iso-8859-1'?%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 14 14' style='enable-background:new 0 0 14 14;' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath style='fill:%233394d9;' d='M7,9L5.268,7.484l-4.952,4.245C0.496,11.896,0.739,12,1.007,12h11.986 c0.267,0,0.509-0.104,0.688-0.271L8.732,7.484L7,9z'/%3E%3Cpath style='fill:%233394d9;' d='M13.684,2.271C13.504,2.103,13.262,2,12.993,2H1.007C0.74,2,0.498,2.104,0.318,2.273L7,8 L13.684,2.271z'/%3E%3Cpolygon style='fill:%233394d9;' points='0,2.878 0,11.186 4.833,7.079 '/%3E%3Cpolygon style='fill:%233394d9;' points='9.167,7.079 14,11.186 14,2.875 '/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.linkedin { 
  background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='windows-1252'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='430.117px' height='430.117px' viewBox='0 0 430.117 430.117' style='enable-background:new 0 0 430.117 430.117;' xml:space='preserve'%3E%3Cg%3E%3Cpath id='LinkedIn' fill='%233394d9' d='M430.117,261.543V420.56h-92.188V272.193c0-37.271-13.334-62.707-46.703-62.707 c-25.473,0-40.632,17.142-47.301,33.724c-2.432,5.928-3.058,14.179-3.058,22.477V420.56h-92.219c0,0,1.242-251.285,0-277.32h92.21 v39.309c-0.187,0.294-0.43,0.611-0.606,0.896h0.606v-0.896c12.251-18.869,34.13-45.824,83.102-45.824 C384.633,136.724,430.117,176.361,430.117,261.543z M52.183,9.558C20.635,9.558,0,30.251,0,57.463 c0,26.619,20.038,47.94,50.959,47.94h0.616c32.159,0,52.159-21.317,52.159-47.94C103.128,30.251,83.734,9.558,52.183,9.558z M5.477,420.56h92.184v-277.32H5.477V420.56z'/%3E%3C/g%3E%3C/svg%3E");
}

.right {
    display: flex;
    gap: 10px;
}
@media all and (max-width:800px) {
  .modal {
    margin: 0 10px;
  }
}
</style>